<template>
  <div class="usermanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;" border>
      <el-table-column prop="createAtMY" label="时间"></el-table-column>
      <el-table-column prop="createUserInfoName" label="用户"></el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {userTabletype,userTablemode} from '@/constants/tablecommon'
import { listAuthRole } from "@/api/authRole";
export default {
  name: "usermanagetable",
  props: {
    tableData: Array
  },
  data() {
    return {
      // userTabletype,
      // userTablemode,
      // tableData:[
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-红色',
        //   moblie:'default-red',
        //   status:0
        // },
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-黑色',
        //   moblie:'default-black',
        //   status:1
        // },{
        //   createMy:'2020-06-22',
        //   name:'默认主题-蓝色',
        //   moblie:'default-blue',
        //   status:0
        // },
      // ]
    };
  },
  methods: {
    moreClick(scope) {
      this.$emit("moreClick", scope);
    }

  },
  created() {
    // this.listAuthRoleAsync()
    
  },
  mounted(){
    // console.log(this.tableData)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover{
  text-decoration: underline;
}
</style>
